<script>
import { Overlay } from '../../'
import { standardIndicator } from '../../workspace/standard-indicators.mjs'
export default {
    name: 'UlcerIndex', mixins: [Overlay],
    methods: {
        meta_info() { return { author:'TradingCandle',version:'1.0.0',desc:'Root mean square percentage drawdown from rolling peaks',
            preset:{ name:'Ulcer Index $length',side:'offchart',settings:{color:'#7e57c2',lineWidth:1.5} } } },
        use_for() { return ['UlcerIndex'] },
        calc() { return {
            props:{length:{def:14,text:'Length'},annualization:{def:252,text:'Periods per year'}},
            conf:{renderer:'Spline'},
            update:`const count = Math.max(2, Math.floor(length)) * 2 + 1;
                const values = series => Array.from({length: count}, (_,i) => series[i]);
                return (${standardIndicator.toString()})('UlcerIndex', values(high), values(low), values(close), [], length, annualization);`
        } },
    },
}
</script>
